import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import MenuItem from '../MenuItem';

import theme from './Menu.scss';

class BaseMenu extends Component {
  static propTypes = {
    menuClassName: PropTypes.string.isRequired,
    size: PropTypes.oneOf(['xsmall', 'small', 'medium', 'large']),
    mediaResized: PropTypes.bool,
    left: PropTypes.number,
    width: PropTypes.number,
    isMenuStickedToTop: PropTypes.bool,
    menuTopOffset: PropTypes.number,
    menuMaxHeight: PropTypes.number,
    items: PropTypes.array.isRequired,
    inputValue: PropTypes.string.isRequired,
    selectedItem: PropTypes.object,
    highlightedIndex: PropTypes.number,
    iconName: PropTypes.string,

    getMenuProps: PropTypes.func.isRequired,
    getItemProps: PropTypes.func.isRequired,

    overlay: PropTypes.bool,
  };

  static defaultProps = {
    size: 'small',
    mediaResized: false,
    left: 0,
    width: 0,
    isMenuStickedToTop: false,
    menuTopOffset: 0,
    menuMaxHeight: 0,
    selectedItem: null,
    highlightedIndex: null,
    iconName: '',

    overlay: false,
  };

  render() {
    const {
      menuClassName,
      size,
      mediaResized,
      left,
      width,
      isMenuStickedToTop,
      menuTopOffset,
      menuMaxHeight,
      items,
      inputValue,
      selectedItem,
      highlightedIndex,
      iconName,
      getMenuProps,
      getItemProps,
      overlay,
    } = this.props;

    return (
      <div
        className={ classnames({
          [theme[size]]: size,
          [theme.mediaResized]: mediaResized,
          [theme.stickedToTop]: isMenuStickedToTop,
          [theme.stickedToBottom]: !isMenuStickedToTop,
        }, theme.menu, menuClassName) }
        { ...getMenuProps() }
        style={{
          top: overlay ? menuTopOffset : isMenuStickedToTop ? 0 : 'auto',
          bottom: !isMenuStickedToTop && !overlay ? 0 : 'auto',
          left: `${ overlay ? left : 0 }px`,
          width: `${ width }px`,
          maxHeight: `${ menuMaxHeight }px`,
        }}
      >
        <MenuItem
          items={ items }
          inputValue={ inputValue }
          selectedItem={ selectedItem }
          highlightedIndex={ highlightedIndex }
          iconName={ iconName }
          size={ size }
          mediaResized={ mediaResized }
          getItemProps={ getItemProps }
        />
      </div>
    );
  }
}

export default BaseMenu;
